module.exports = __webpack_public_path__ + "img/img_index_logo_institute@2x.f2db6ae4.png";